import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGitterComponent } from './simple-icons-gitter.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGitterComponent ],
    exports:      [ SimpleIconsGitterComponent ],
    bootstrap:    []
})
export class SimpleIconsGitterModule {}
